import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getAttendedPresentationList: {
    method: 'GET',
    url: `${configs.baseUrl}/api/attended-presentations`,
  },
  getAttendedPresentationDetail: {
    method: 'GET',
    url: `${configs.baseUrl}/api/attended-presentations/{id}`,
  },
  createAttendedPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/attended-presentations`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getAttendedPresentationList = async ({ page, pageSize }) => {
  const res = await resource.getAttendedPresentationList({ page, pageSize })

  return res.body
}

const getAttendedPresentationDetail = async (id) => {
  const res = await resource.getAttendedPresentationDetail({ id })

  return res.body
}

const createAttendedPresentation = async (payload) => {
  const res = await resource.createAttendedPresentation(payload)

  return res.body
}

export default {
  initResource,
  getAttendedPresentationList,
  getAttendedPresentationDetail,
  createAttendedPresentation,
}
